export default {
  name: 'CustomButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    background: {
      type: String,
      default: '#0099FF',
    },
    textColor: {
      type: String,
      default: '#fff',
    },
    border: {
      type: String,
      default: 'none',
    },
    borderRadius: {
      type: Number,
      default: 0,
    },
    isDefaultHover: {
      type: Boolean,
      default: false,
    },
    isAnimateHover: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: Number,
      default: 16,
    },
    resizeOnMobile: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: '15px 40px',
    },
  },

  methods: {
    handleClick() {
      if (!this.disabled) this.$emit('click');
    },
    isMobile() {
      return window.innerWidth < 700;
    },
  },
};
